const USDT_ALLOWANCE_LOADING = 'USDT_ALLOWANCE_LOADING';
const USDT_ALLOWANCE_SUCCESS = 'USDT_ALLOWANCE_SUCCESS';
const USDT_ALLOWANCE_FAILURE = 'USDT_ALLOWANCE_FAILURE';

export const usdtAllowanceActions = {
  USDT_ALLOWANCE_LOADING,
  USDT_ALLOWANCE_SUCCESS,
  USDT_ALLOWANCE_FAILURE,
};
